import { useQuery } from "@tanstack/react-query";

import { useAuthHeaders } from "../auth/apiClient";

export interface CustomerSmsMessage {
  id: string;
  source: "twilio_inbound" | "twilio_outbound" | "messages_sent_outbound";
  message_sid: string | null;
  direction: "in" | "out";
  from: string | null;
  to: string | null;
  body: string;
  status: string;
  error_code: number | null;
  error_message: string | null;
  date: string;
  quote_id: string | null;
  template_id: string | null;
  is_stop: boolean;
  is_opted_out_phone: boolean;
}

export interface CustomerSmsThread {
  customer_id: number;
  phones: string[];
  opted_out_phones: Array<{
    phone: string;
    reason: string;
    opted_out_at: string;
  }>;
  messages: CustomerSmsMessage[];
  stats: {
    total: number;
    inbound: number;
    outbound: number;
    last_message_at: string | null;
  };
  generated_at: string;
}

export function useCustomerSms(contactId: number | null, enabled = true) {
  const headers = useAuthHeaders();
  return useQuery({
    queryKey: ["customer-sms", contactId],
    queryFn: async () => {
      const res = await fetch(`/api/cockpit/customers/${contactId}/sms`, {
        headers,
      });
      if (!res.ok) throw new Error("Customer SMS failed");
      return res.json() as Promise<CustomerSmsThread>;
    },
    enabled: !!contactId && enabled,
    staleTime: 60_000,
  });
}
